import { Box, Button, LoadingOverlay, SegmentedControl, Stack, Table, Text } from '@mantine/core';
import { ReactNode } from 'react';

import { dictionaryTypes } from '../types';

import { ListLoader } from '@/components';

type Props = {
  viewMode: dictionaryTypes.ViewMode;
  onViewModeChange: (viewMode: dictionaryTypes.ViewMode) => void;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  onRetry: () => void;
  columnLabel: string;
  errorText: string;
  emptyText: string;
  isEmpty: boolean;
  children: ReactNode;
};

export const DictionaryList = ({
  viewMode,
  onViewModeChange,
  isLoading,
  isFetching,
  isError,
  onRetry,
  columnLabel,
  errorText,
  emptyText,
  isEmpty,
  children,
}: Props) => {
  if (isLoading) {
    return <ListLoader height="calc(100vh - 150px)" />;
  }

  const renderContent = () => {
    if (isError) {
      return (
        <Stack align="flex-start" gap="xs">
          <Text c="red">{errorText}</Text>
          <Button variant="light" size="xs" onClick={onRetry}>
            Retry
          </Button>
        </Stack>
      );
    }

    if (isEmpty) {
      return (
        <Text size="sm" c="dimmed">
          {emptyText}
        </Text>
      );
    }

    return (
      <Table stickyHeader striped highlightOnHover>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{columnLabel}</Table.Th>
            <Table.Th />
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{children}</Table.Tbody>
      </Table>
    );
  };

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 150px)', gridTemplateRows: 'auto 1fr' }}>
      <Box py="md">
        <SegmentedControl
          value={viewMode}
          onChange={(value) => onViewModeChange(value as dictionaryTypes.ViewMode)}
          data={[
            { label: 'Active', value: 'active' },
            { label: 'Archived', value: 'archived' },
          ]}
        />
      </Box>
      <Box style={{ overflow: 'auto', position: 'relative' }}>
        <LoadingOverlay visible={isFetching} />
        {renderContent()}
      </Box>
    </Box>
  );
};
